import * as tslib_1 from "tslib";
import * as React from 'react';
import styled from 'styled-components';
var IconButton = /** @class */ (function (_super) {
    tslib_1.__extends(IconButton, _super);
    function IconButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isFocus: false };
        _this.getSetFocus = function (onOrOff) { return function () { return _this.setState({ isFocus: onOrOff }); }; };
        return _this;
    }
    IconButton.prototype.render = function () {
        return (React.createElement("a", { href: this.props.url },
            React.createElement(Container, { tabIndex: -1, onFocus: this.getSetFocus(true), onBlur: this.getSetFocus(false) },
                React.createElement(Icon, { src: !this.state.isFocus === true ? this.props.src : this.props.hoverImg }))));
    };
    return IconButton;
}(React.Component));
export default IconButton;
var Container = styled.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    &:focus{\n        outline:0;\n    }\n"], ["\n    &:focus{\n        outline:0;\n    }\n"])));
var Icon = styled.img(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n    width:75px;\n    align-self:center;\n"], ["\n    width:75px;\n    align-self:center;\n"])));
var templateObject_1, templateObject_2;



//////////////////
// WEBPACK FOOTER
// ./src/Components/Icon.tsx
// module id = 38
// module chunks = 0